import { ButtonProps } from '@mui/material';
import { ButtonContainedStyled } from './j-button.styled';

interface Props extends Omit<ButtonProps, ''> {
  children: React.ReactNode;
  guttertop?: boolean;
}

export const JButton = (props: Props) => {
  const { children, guttertop: gutterTop, variant, color } = props;

  return (
    <ButtonContainedStyled
      variant={variant}
      color={color}
      guttertop={gutterTop}
      data-qa={`button-${children?.toString()}`}
      {...props}
    >
      {children}
    </ButtonContainedStyled>
  );
};
